<form [formGroup]="form" novalidate>
   <div class="mb-3">
      <label for="addr-line1" class="form-label fw-bold">Street Address</label>
      <input id="addr-line1"
             type="text"
             class="form-control"
             formControlName="line1"
             maxlength="120"
             autocomplete="address-line1" />
      @if (form.get('line1')?.touched && form.get('line1')?.invalid) {
         <em class="error-msg-block">Enter the street address.</em>
      }
   </div>

   <div class="mb-3">
      <label for="addr-line2" class="form-label">Apt, Suite, etc. (optional)</label>
      <input id="addr-line2"
             type="text"
             class="form-control"
             formControlName="line2"
             maxlength="120"
             autocomplete="address-line2" />
   </div>

   <div class="mb-3">
      <label for="addr-city" class="form-label fw-bold">City</label>
      <input id="addr-city"
             type="text"
             class="form-control"
             formControlName="city"
             maxlength="80"
             autocomplete="address-level2" />
      @if (form.get('city')?.touched && form.get('city')?.invalid) {
         <em class="error-msg-block">Enter the city.</em>
      }
   </div>

   <div class="mb-3">
      <label for="addr-country" class="form-label fw-bold">Country</label>
      <select id="addr-country"
              class="form-select"
              formControlName="countryCode"
              autocomplete="country">
         @for (country of countries; track country.code) {
            <option [ngValue]="country.code">{{ country.name }}</option>
         }
      </select>
      @if (form.get('countryCode')?.touched && form.get('countryCode')?.invalid) {
         <em class="error-msg-block">Select a country.</em>
      }
   </div>

   <div class="mb-3">
      <label for="addr-state" class="form-label fw-bold">State / Province</label>
      <select id="addr-state"
              class="form-select"
              formControlName="stateProvinceCode"
              autocomplete="address-level1">
         <option [ngValue]="null">-- Select a state / province --</option>
         @for (state of statesForCountry(); track state.code) {
            <option [ngValue]="state.code">{{ state.name }}</option>
         }
      </select>
      @if (form.get('stateProvinceCode')?.touched && form.get('stateProvinceCode')?.invalid) {
         <em class="error-msg-block">Select a state / province.</em>
      }
   </div>

   <div class="mb-3">
      <label for="addr-postal" class="form-label fw-bold">Postal Code</label>
      <input id="addr-postal"
             type="text"
             class="form-control"
             formControlName="postalCode"
             maxlength="20"
             autocomplete="postal-code" />
      @if (form.get('postalCode')?.touched && form.get('postalCode')?.invalid) {
         <em class="error-msg-block">Enter a valid postal code.</em>
      }
   </div>
</form>
